import React,{useEffect, useState} from 'react'
// import log from '../assets/images/log.png'
import styles from "./Subscribe.module.css";
import axios from 'axios';
import qs from 'qs';
import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';
import { ToastContainer, toast } from 'react-toastify';
import { getHeadersApi, subscribe_api } from '../Services/integrationApi';




function Subscribe() {

  const [number,setNumber] = useState(null);
  const [loading,setLoading] = useState(false)
  const [ip,setIP] = useState(null);
  // =======new=========
 const [token,setToken] = useState(null)

  const [subLoading,setSubLoading] = useState(false);
  // =============new================
   const [userAgent,setUserAgent] = useState(null)

   useEffect(() => {
  const user_agent = navigator.userAgent;
  console.log("User-Agent:", user_agent);
  setUserAgent(user_agent);
}, []);


  // let token = Cookies.get('token') // => 'value'========================me===========

  useEffect(() => {
    const fetchIP = async () => {
      try {
        const res = await axios.get('https://api.ipify.org?format=json');
        setIP(res.data.ip);
      } catch (err) {
        console.log('Error fetching IP:', err);
      }
    };

    fetchIP();
  }, []);

  console.log(ip)





  console.log(loading)
  const params = new URLSearchParams(window.location.search)
  const ext_ref = params.get('ext_ref') || uuidv4();

  const getHeadersToken=async()=>{

    console.log('headers-------------------')
    
    try{
      const response = await axios.post(getHeadersApi)
      console.log(response)
      setToken(response.data)
    }
    catch(err){
      // console.log(err.response.data.err.header.customerMessage)
      console.log(err?.response?.data?.err?.header?.customerMessage || "Error fetching token")

    }
  }



// ================================new============================
console.log(token)

  useEffect(()=>{
    getHeadersToken()
  },[])






   const getHeaders=async()=>{
    // setLoading(true)
    console.log('getHeaders-------------------')
    try{
      setLoading(true)

      console.log(token);

      if(!token){
        //  token = await getToken();
        console.log('no token present')
        return;
      }
      
      // console.log(token);

      const xhr = new XMLHttpRequest();
      const url = 'https://identity.safaricom.com/partner/api/v2/fetchMaskedMsisdn';
    
      xhr.open('GET', url, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Authorization', `Bearer ${token}`);
      xhr.setRequestHeader('X-App', 'he-partner');
      xhr.setRequestHeader('X-Source-System', 'he-partner');
      xhr.setRequestHeader('X-MessageID', '1234');

      console.log(xhr,'xhr--------')

      
      
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            try {
              const response = JSON.parse(xhr.responseText);
              console.log(response, 'response...');
              
              // Extract the Msisdn value safely
              const msisdn = response?.ServiceResponse?.ResponseBody?.Response?.Msisdn ?? null;
              
              if (msisdn) {
                // Auto sign-in user
                console.log(msisdn)
                setNumber(msisdn)
                setLoading(false)
                
              } else {
                // setLoading(false);
                
              }
            } catch (error) {
              console.error('Error parsing response:', error);
              // setLoading(false);
             
            }
          } else {
            console.error('Request failed with status:', xhr.status);
            // setLoading(false);
          }
        }
      };
    
      xhr.send();

      // console.log(res)


    }
    catch(err){
      console.log(err);
      // setLoading(false)
    }
    // setLoading(false)
  }







  console.log(number)

  useEffect(()=>{
    getHeaders()
  },[token])

  const handleSubmit=async(e)=>{
    console.log(number,'number')
    e.preventDefault();

    setSubLoading(true)
    const data={
      ani:number,
      ext_ref:ext_ref,
      ip_address:ip,
      user_agent:userAgent
    }
   
    if(number){
      try{
        // console.log('number-----------',(number))
        const res = await axios.post(subscribe_api,data)
        console.log(res.data)

        if(! res.data.result.cg_url){
          setSubLoading(false)
          toast.error(res?.data?.message)
        }

        window.location.href = res.data.result.cg_url;

        

        setTimeout(()=>{
          setSubLoading(false)
        },5000)
     
    }
    catch(err){
      console.log(number)
      setTimeout(()=>{
        setSubLoading(false)
      },5000)
    }
    }
    
  
    
  }

  return (
    <div  className='bg-[url("https://images.pexels.com/photos/3165335/pexels-photo-3165335.jpeg?cs=srgb&dl=pexels-lulizler-3165335.jpg&fm=jpg")] flex justify-center items-center h-screen bg-black' >
      <h1></h1> 
<form
  class="text-neutral-800 relative overflow-hidden flex flex-col justify-around w-[30rem]  bg-black  border border-white/10 rounded-2xl p-10 w-[36rem]"
  onSubmit={handleSubmit}
>
<img src='/static/media/logo.f593d3983bb9e2d1faef.png' />
  <div
    class=" flex flex-col items-center before:absolute before:w-32 before:h-20 before:right-2 before:bg-rose-300 before:-z-10 before:rounded-full before:blur-xl before:-top-12 z-10 after:absolute after:w-24 after:h-24 after:bg-orange-300 after:-z-10 after:rounded-full after:blur after:-top-12 after:-right-6"
  >
   <h2 className="tlt text-3xl font-bold" data-in-effect="fadeInLeft">
              H2N <span className='text-yellow-400'>GAMES</span>
              </h2>
              <br/>
  
    <p class=" text-xl font-bold text-white text-center">
    Your Daily Dose of Fun & Games.
    </p>
    {/* <br/> */}
  </div>
  <div class="flex flex-col items-center gap-2">
    
    <div className='text-xl font-semibold text-[#f3e739] p-2'>
  Price 15KSH/Daily 
    </div>
    <button
    type="submit"
    className={`${styles.defaultbutton}  w-[16rem]  border-2 border-[#ea7414] text-black ${!number && 'bg-gray-500 border-black'} ${number &&  'cursor-pointer bg-[#ea7414] text-white'}`}
    disabled={(!number) || (subLoading) }
    >
      Subscribe
    </button>
    { !number && <p className='text-red-500 text-center'>** Switch To Safaricom Network To Subscribe **</p> }
   
  </div>
</form>

    </div>
  )
}

export default Subscribe
